<!-- Mapová legenda -->
<!-- Karta pro jednu mapovou vrstvu -->
<template>
  <!-- <v-badge
    :color="MapLegendLayer.layer.visible ? 'green' : '#FF0000'"
    offset-x="10"
    offset-y="16"
    class="my-1"
    left
  > -->
  <!-- @click="MapLegendLayer.layer.visible = !MapLegendLayer.layer.visible" -->
  <v-card :disabled="!MapLegendLayer.inited" width="220" color="transparent">
    <v-hover v-slot="{ hover }">
      <v-card width="220" min-height="140" color="white" class="my-1"
        @click="MapLegendLayer.layer.visible = !MapLegendLayer.layer.visible">
        <v-img :src="AssetsUrl + '/' + MapLegendLayer.legend.image" class="fill-height" position="center top"
          height="140" :gradient="hover
            ? 'to top , rgba(0,96,100,0.2), rgba(0,96,100,0.9)'
            : MapLegendLayer.layer.visible
              ? 'to top , rgba(255,111,23,0.2), rgba(255,111,23,0.9)'
              : 'to top , rgba(0,0,0,0.2), rgba(0,0,0,0.9)'
            ">
          <v-card-title class="pa-1 ml-2 text-subtitle-1" v-html="MapLegendLayer.label"></v-card-title>

          <v-card-subtitle class="pa-3 ml-2 text-subtitle-2" v-html="MapLegendLayer.labelsub"></v-card-subtitle>
        </v-img>
      </v-card>
    </v-hover>

    <v-menu v-if="LayerOpacityChangeYN" v-model="LayerTransparencySliderView" :close-on-content-click="false" offset-x
      content-class="overflow-y-hidden">
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" v-model="LayerTransparencySliderView" color="rgba(0,0,0,0.6)" dark rounded small
          absolute class="pa-0 mb-1 ml-1 u_posBottom">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">
                {{ LayerTransparency + " %" }}
              </span>
            </template>
            <span>Průhlednost</span>
          </v-tooltip>
        </v-btn>
      </template>

      <v-card class="px-2" color="toolBar2" flat width="200">
        <v-slider v-model="LayerTransparency" class="align-center" max="80" min="0" step="10" thumb-color="accent2"
          hide-details dense>
        </v-slider>
      </v-card>
    </v-menu>

    <v-tooltip right v-if="LayerScaleLimit">
      <template v-slot:activator="{ on, attrs }">
        <v-btn x-small fab v-bind="attrs" v-on="on" @click="MapViewZoomToScale(MapLegendLayer.layer.scaleRange.min)"
          absolute class="ma-1 u_posRigth u_posTop" color="rgba(0,0,0,0.6)">
          <v-icon color="accent2 ">mdi-arrow-expand-vertical</v-icon>
        </v-btn>
      </template>
      <span class="">{{ LayerScaleLimit }}</span>
    </v-tooltip>

    <v-tooltip right v-if="MapLegendLayer.legend.staticLegName">
      <template v-slot:activator="{ on, attrs }">
        <v-btn x-small fab v-bind="attrs" v-on="on" @click="
          MapLayerLegendStaticSet(MapLegendLayer.id, MapLegendLayer.legend.title, StaticMapLegend)
          " absolute class="ma-1 u_posRigth u_posTop mt-10" color="rgba(0,0,0,0.6)">
          <v-icon color="accent2 ">mdi-map-legend</v-icon>
        </v-btn>
      </template>
      <span class="">Legenda</span>
    </v-tooltip>

    <v-tooltip right v-if="MapLegendLayer.legend.dynamicLegName">
      <template v-slot:activator="{ on, attrs }">
        <v-btn x-small fab v-bind="attrs" v-on="on" @click="
          MapLayerLegendDynamicSet(MapLegendLayer.id, MapLegendLayer.legend.title, MapLegendLayer.legend.dynamicLegName)
          " absolute class="ma-1 u_posRigth u_posTop mt-10" color="rgba(0,0,0,0.6)">
          <v-icon color="accent2 ">mdi-map-legend</v-icon>
        </v-btn>
      </template>
      <span class="">Legenda</span>
    </v-tooltip>





    <span class="u_posAbs u_posRigth u_posBottom">

      <v-menu v-if="MapLegendLayer.change" transition="scale-transition">

        <template v-slot:activator="{ on: menu, attrs }">
          <v-tooltip top>
            <template v-slot:activator="{ on: tooltip }">
              <v-btn small fab v-bind="attrs" v-on="{ ...tooltip, ...menu }" color="rgba(0,0,0,0.6)" class="ma-1">
                <v-icon color="accent2 ">mdi-layers-edit</v-icon>
              </v-btn>
            </template>
            <span class="" v-html="MapLegendLayer.change.label"></span>
          </v-tooltip>
        </template>

        <v-list dense max-height="300" class=" overflow-y-auto">
          <v-list-item-group mandatory v-model="SelectedChangeListIndex" color="accent2" return-object>
            <v-list-item v-for="(item, index) in MapLegendLayer.change.list" :key="index">
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu>


      <v-tooltip right v-if="MapLegendLayer.removable">
        <template v-slot:activator="{ on, attrs }">
          <v-btn small fab v-bind="attrs" v-on="on" @click="MapLegendRemoveLayer(MapLegendLayer.id)" class="ma-1"
            color="rgba(0,0,0,0.6)">
            <v-icon color="error ">mdi-delete</v-icon>
          </v-btn>
        </template>
        <span>Odstranit vrstvu</span>
      </v-tooltip>

    </span>

  </v-card>
  <!-- </v-badge> -->
</template>

<script>
export default {
  props: {
    // Mapová vrstva
    MapLegendLayer: Object,
    // Adresa na Assets
    AssetsUrl: null,
    // Mapová služba
    ServiceMap: null,
    // Viditelnost legendy
    MapLayerLegend_view: null,
    // id vrstvy, ke které se legenda vztahuje
    MapLayerLegend_layerId: null,
  },

  data() {
    return {
      // Průhlednost vrstvy 0 (neprůhledná) - 100
      LayerTransparency: 0,
      // přepinač na viditelnost posuvníku
      LayerTransparencySliderView: false,
      // Změny vrstvy - index vybraného
      SelectedChangeListIndex: null,
      // Statická legenda
      StaticMapLegend: null,
    };
  },

  watch: {
    // Nastavení průhlednosti vrstvy
    LayerTransparency(value) {

      //console.log("LayerTransparency", value, oldValue, this.MapLegendLayer.opacity)

      var newOpacity = (1 - value / 100)

      if (this.MapLegendLayer.opacity != newOpacity) {
        //console.log("set opacity")

        this.MapLegendLayer.opacity = newOpacity

        if (typeof this.MapLegendLayer.layer.rasterStyle !== 'undefined') {
          this.MapLegendLayer.layer.rasterStyle = { alpha: newOpacity };
        } else if (typeof this.MapLegendLayer.layer.painter !== 'undefined' && typeof this.MapLegendLayer.layer.painter.opacity !== 'undefined') {
          this.MapLegendLayer.layer.painter.opacity = newOpacity;
        } else if (this.MapLegendLayer.type == 'LayerGroup') {
          this.MapLegendLayer.layer.children.forEach(
            function (item) {
              if (typeof item.rasterStyle !== 'undefined') {
                item.rasterStyle = { alpha: newOpacity };
              } else if (typeof item.painter !== 'undefined' && typeof item.painter.opacity !== 'undefined') {
                item.painter.opacity = newOpacity;
              }
            }
          )
        }
      }
    },


    // Viditelnost vrstvy
    LayerVisible(value) {
      if (this.MapLegendLayer.type == 'LayerGroup') {
        // Změna viditelnosti pro případné podřízené vrstvy
        this.MapLegendLayer.layer.children.forEach((element) => {
          element.visible = value;
        })
      }
    },

    // Změna obsahu (adresy) vrstvy
    SelectedChangeListIndex(value, oldValue) {
      // console.log(oldValue);
      // console.log(value);
      // console.log(this.MapLegendLayer);

      if (oldValue != null) {

        var OldSelectedChangeList = this.MapLegendLayer.change.list[oldValue];
        var NewSelectedChangeList = this.MapLegendLayer.change.list[value];

        this.MapLegendLayer.label = NewSelectedChangeList.label;
        this.MapLegendLayer.labelsub = NewSelectedChangeList.labelsub;
        if (NewSelectedChangeList.legendImage) {
          this.MapLegendLayer.legend.image = NewSelectedChangeList.legendImage;
        }

        this.MapLegendLayerChangeBaseURL(this.MapLegendLayer.id, OldSelectedChangeList.changeBaseURL, NewSelectedChangeList.changeBaseURL)

        if (NewSelectedChangeList.legendStaticLegName) {
          this.MapLegendLayer.legend.title = NewSelectedChangeList.legendTitle;
          this.MapLegendLayer.legend.staticLegName = NewSelectedChangeList.legendStaticLegName;
          this.NactiStaticMapLegend(NewSelectedChangeList.legendStaticLegName);
        }


      }
    },


  },

  methods: {

    // Změna mapového výřezu na cílové měřítko - volá se funkce v nadřazeném objektu
    MapViewZoomToScale: function (value) {
      this.$emit('MapViewZoomToScale', value);
    },
    // Funkce pro odstranění vrstvy - volá se funkce v nadřazeném objektu
    MapLegendRemoveLayer: function (id) {
      this.$emit('MapLegendRemoveLayer', id);
    },
    // Funkce pro změnu zdroje vrstvy - volá se funkce v nadřazeném objektu
    MapLegendLayerChangeBaseURL: function (id, oldValue, newValue) {
      this.$emit('MapLegendLayerChangeBaseURL', id, oldValue, newValue);
    },
    // Statická mapová legenda - proměnná pro vybranou vrstvu - volá se funkce v nadřazeném objektu
    MapLayerLegendStaticSet: function (layerId, title, content) {
      this.$emit('MapLayerLegendStaticSet', layerId, title, content);
    },
    // Dynamická mapová legenda - proměnná pro vybranou vrstvu - volá se funkce v nadřazeném objektu
    MapLayerLegendDynamicSet: function (layerId, title, content) {
      this.$emit('MapLayerLegendDynamicSet', layerId, title, content);
    },


    // Načtení statické legendy
    NactiStaticMapLegend: function (Jmeno) {
      this.ServiceMap.MapLegend(Jmeno)
        .then((response) => {
          if (response.data.Dokonceno) {
            this.StaticMapLegend = response.data.Vypis;
            if (this.MapLayerLegend_view && this.MapLayerLegend_layerId == this.MapLegendLayer.id) {
              this.MapLayerLegendStaticSet(this.MapLegendLayer.id, this.MapLegendLayer.legend.title, this.StaticMapLegend)
            }
          } else {
            return null;
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .then(function () {
          // always executed
        });
    },
  },

  computed: {
    // Viditelnost vrtsvy
    LayerVisible: function () {
      return this.MapLegendLayer.layer.visible
    },
    // Zda je možné měnit průhlednost
    LayerOpacityChangeYN: function () {
      if ((typeof this.MapLegendLayer.layer.rasterStyle !== 'undefined') ||
        (typeof this.MapLegendLayer.layer.painter !== 'undefined' && typeof this.MapLegendLayer.layer.painter.opacity !== 'undefined')) {
        return true
      } else if (
        this.MapLegendLayer.type == 'LayerGroup' &&
        (this.MapLegendLayer.layer.children.filter(function (item) {
          return (typeof item.rasterStyle !== 'undefined') || (typeof item.painter !== 'undefined' && typeof item.painter.opacity !== 'undefined');
        }).length > 0)
      ) {
        return true
      } else {
        return false
      }

    },
    // popis zobrazjící rozsah zobrazení - měřítka
    LayerScaleLimit: function () {
      // console.log(this.MapLegendLayer.layer.scaleRange);
      // console.log(isFinite(this.MapLegendLayer.layer.scaleRange.max));
      // console.log(isFinite(this.MapLegendLayer.layer.scaleRange.min));
      // console.log(Math.trunc(1 / this.MapLegendLayer.layer.scaleRange.max));
      // console.log(Math.trunc(1 / this.MapLegendLayer.layer.scaleRange.min));

      if (this.MapLegendLayer.layer.treeNodeType !== 'LAYER_GROUP') {

        if (
          !isFinite(this.MapLegendLayer.layer.scaleRange.max) &&
          !isFinite(this.MapLegendLayer.layer.scaleRange.min)
        ) {
          return null;
        } else {
          var vText = "";

          vText += isFinite(this.MapLegendLayer.layer.scaleRange.max)
            ? Intl.NumberFormat("cz-CZ").format(
              Math.trunc(1 / this.MapLegendLayer.layer.scaleRange.max)
            )
            : "1";

          vText += " - ";
          vText += isFinite(this.MapLegendLayer.layer.scaleRange.min)
            ? Intl.NumberFormat("cz-CZ").format(
              Math.trunc(1 / this.MapLegendLayer.layer.scaleRange.min)
            )
            : "∞";

          return vText;
        }
      } else {
        return null;
      }

    },
  },

  mounted() {

    //console.log("Item", this.MapLegendLayer, this.LayerTransparency)

    // Nastavení výchozí průhlednosti
    this.LayerTransparency = (1 - this.MapLegendLayer.opacity) * 100

    // Načtení statické legendy
    if (this.MapLegendLayer.legend.staticLegName) {
      this.NactiStaticMapLegend(this.MapLegendLayer.legend.staticLegName);
    }
  },
};
</script>